import Routes from '../../routes'

export const RouteReplace = (route, locale) => {
  if (window && typeof window.location.replace === 'function') {
    const urls = Routes.findAndGetUrls(route, locale)
    if (urls) {
      window.location.replace(Routes.findAndGetUrls(route, locale).urls.as)
    }
  }
}

export const RouteAssign = (route, locale) => {
  if (window && typeof window.location.assign === 'function') {
    const urls = Routes.findAndGetUrls(route, locale)
    if (urls) {
      window.location.assign(Routes.findAndGetUrls(route, locale).urls.as)
    }
  }
}


// WEBPACK FOOTER //
// src/helpers/routing.js